// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WatchlistManager } from './WatchlistManager';
import { WatchlistSheetItem } from './WatchlistSheetItem';
import { WatchlistSheetsStorageManager } from './WatchlistSheetsStorageManager';
import { CustomEvent } from '../../CustomEvents';
import { InstrumentDescriptionUtils } from '../../Instruments/InstrumentDescriptionUtils';
export class _WatchlistSheets {
    constructor() {
        this._items = [];
    }
    get items() {
        return this._items;
    }
    set items(_items) {
        this._items = _items;
        this.onSettingsChanged();
    }
    restore(newWLSheets) {
        for (const key in newWLSheets) {
            if (Object.prototype.hasOwnProperty.call(newWLSheets, key)) {
                this[key] = newWLSheets[key];
            }
        }
        this.onSettingsChanged();
    }
    getAllInstrumentDescriptions(items) {
        const symbolIds = [];
        items.forEach((item) => {
            symbolIds.push(...item.getAvailableInstrumentDescriptions());
        });
        return symbolIds;
    }
    static serialize(wlItems) {
        const saveList = wlItems.map((item) => ({
            name: item.name,
            items: item.getInstrumentDescriptions()
        }));
        return JSON.stringify(saveList);
    }
    static deserialize(json) {
        const wlSheets = new _WatchlistSheets();
        const sheets = JSON.parse(json);
        sheets.forEach((sheet) => {
            if (isNullOrUndefined(sheet.name))
                return;
            const instrDescriptions = this.parseInstrumentDescriptions(sheet);
            wlSheets.items.push(new WatchlistSheetItem(sheet.name, instrDescriptions));
        });
        return wlSheets;
    }
    static parseInstrumentDescriptions(sheet) {
        const parsedNewFormat = this.parseNewFormat(sheet.items);
        if (parsedNewFormat.length > 0) {
            return parsedNewFormat;
        }
        return this.parseOldFormat(sheet.itemsStr);
    }
    static parseNewFormat(items) {
        if (!Array.isArray(items)) {
            return [];
        }
        return items.filter((item) => typeof item.id === 'string' && typeof item.tradableId === 'number' && typeof item.routeId === 'number');
    }
    static parseOldFormat(itemsStr) {
        if (!itemsStr) {
            return [];
        }
        return itemsStr
            .split(';')
            .filter(Boolean)
            .map((symbolId) => {
            const instrDescr = InstrumentDescriptionUtils.createFromInteriorId(symbolId);
            if (isNullOrUndefined(instrDescr)) {
                return null;
            }
            return instrDescr;
        })
            .filter((item) => item !== null);
    }
    onSettingsChanged() {
        _WatchlistSheets.itemsChanged.Raise();
        WatchlistSheetsStorageManager.wasChanged();
        WatchlistManager.updateStorageItems();
    }
}
_WatchlistSheets.itemsChanged = new CustomEvent();
export const WatchlistSheets = new _WatchlistSheets();
